import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Avatar, Ibox } from 'enspire-manager-framework';
import { PERMISSIONS, WORKORDERS } from 'components/constants';
import { Table } from 'em-table';
import { imageSize, numPanels } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const WorkOrdersTab = (props) => {
    
    /* Hooks --------------------------*/
    
    const seg = 3;
    const params = useParams();
    const history = useHistory();
    const routeLocation = useLocation();

	const user = useSelector(store => store.users?.user);
	const user_permissions = useSelector(store => store.users?.user_permissions);
    const employees = useSelector((store) => store.employees);
    const service_request = useSelector((store) => store.serviceRequests.service_request);
    const workOrders = useSelector((store) => store.workOrders);

    const [data, setData] = useState([]);

	/* Effects --------------------------*/

    useEffect(() => {
        var work_orders = [];
        workOrders?.work_orders?.forEach((workOrder) => {

            // Permissions ----------------------------------------
            const isTeamWO = (service_request?.techIds?.includes(user?.profileId) || service_request?.techIds?.includes(user?.email));
            let canViewMyWO = (
                workOrder?.technicianId == user?.profileId || 
                workOrder?.ownerId == user?.email ||
                (isTeamWO && user_permissions[PERMISSIONS.WORK_ORDERS_TEAM_VIEW.key]) ||
                user_permissions[PERMISSIONS.WORK_ORDERS_VIEW.key]
            );

            let status = _.find(Object.values(WORKORDERS), { id: workOrder.statusId });
            let technician = employees.employees?.find((o) => o.id == workOrder.technicianId);
        
            work_orders.push({...workOrder,
                _stripe_color: status?.color,
                _no_click: !canViewMyWO,
                name: ((technician)
                    ? (technician?.contact?.firstName || technician?.contact?.lastName) 
                        ? technician?.contact?.firstName + ' ' + technician?.contact?.lastName 
                        : 'Unknown'
                    : 'Unassigned'),
                status: status?.name,
                totalCost: workOrder?.totals?.grandTotal || 0,
                image: <Avatar className="mx-auto my-n1"
                    color="white"
                    bgColor="steelblue"
                    size={50}
                    fontSize={'18px'}
                    name={(technician) ? technician.contact?.firstName + ' ' + technician.contact?.lastName : 'Unassigned'}
                    image={technician?.contact.photoUrl ? imageSize(technician?.contact.photoUrl, 'sm') : null}
                    imageWidth={60}
                    border="4px solid white"
                    // role={ (asset.imageUrl) ? "button" : null }
                />
            });
        });
        setData(work_orders);
    }, [workOrders?.work_orders, user_permissions]);

    const newWorkOrder = () => {
        let location = toolbox.modifyPath(routeLocation.pathname, seg+2, 'work-order-form/0');
        history.push({ pathname: location });
    }

    /* Constants --------------------------*/

    const redistWidth = 50;
    const redist = (num) => (numPanels() > 1) ? num : num + (num / (100 - redistWidth) * (redistWidth));
    const columns = [
        { name: 'ID', field: 'customId', width: redist(10) },
        { name: 'Technician', field: 'name', width: redist(25) },
        { name: 'Summary', field: 'description', ...(!numPanels(1)) ? { width: 50 } : {} },
        { name: 'Total Cost', field: 'totalCost', type: 'number', format: 'usd', text_align: 'right', width: redist(15) },
    ];

    return (
        <Ibox title={"Work Orders"}
            button={" + Work Order "}
            button_callback={newWorkOrder}
            button_disabled={ !user_permissions[PERMISSIONS.WORK_ORDERS_CREATE.key] }
        >
            <Table id="work-order-tab"
                active_field={'id'}
                active_id={params.tab_id}
                chevron={true}
                click_callback={(workOrder) => {
                    let location = toolbox.modifyPath(routeLocation.pathname, seg+7, workOrder.id + '/items', seg+9);
                    let segments = routeLocation.pathname.split('/').length;
                    
                    if (segments < 12) {
                        history.push({ pathname: location });
                    } else {
                        history.replace({ pathname: location });
                    }
                }}
                columns={columns}
                data={data}
                highlight_search={true}
                image={'image'}
                imageWidth={55}
                limit={10}
                order_by = {{ fields: ['id'], direction: ['desc'] }}
                second_line={(numPanels(1)) ? 'description' : ''}
                second_line_prefix={<i className="fa-solid fa-circle-arrow-right fa-lg mr-1"></i>}
                show_search={false}
            >
            </Table>
        </Ibox>
    );
};

export default WorkOrdersTab;